export default "__VITE_ASSET__C1U6fZJq__"